import React from 'react';
import NextLink from 'next/link';
import { Button } from '@chakra-ui/react';

function ViewAllLink({
  href,
  onClick,
  label = 'すべて見る',
  type = 'fullWidthButton',
}: {
  href: string;
  onClick?: () => void;
  label?: React.ReactNode;
  type?: 'fullWidthButton' | 'noPadding';
}) {
  const style =
    type === 'fullWidthButton'
      ? {
          mt: 4,
          w: '100%',
          p: '17.5px',
          border: '1px solid',
          borderColor: 'brand.500',
        }
      : {
          w: 'auto',
          p: 0,
        };

  return (
    <NextLink href={href} passHref>
      <Button
        as="a"
        bg="white.500"
        color="brand.500"
        height={4}
        fontSize={14}
        _hover={{
          bg: 'white.500',
          textDecoration: 'underline',
        }}
        onClick={() => onClick?.()}
        {...style}
      >
        {label}
      </Button>
    </NextLink>
  );
}

export default ViewAllLink;
